import { useEffect, useState } from "react";
import { useParams } from "react-router";
import MainLayout from "@/components/layouts";
import { Skeleton } from "@/components/ui/skeleton";
import ContactAppointmentPage from "@/app/contact/appointment.page";
import { useAppSelector } from "@/lib/store";
import { PropertyContactRepository } from "@/repositories/property-contact.repository";
import IndividualAppointmentUpdatePage from "./update";
import { worksTheJob } from "./own-work";

type Seat = "loading" | "worker" | "contact";

export default function WorkerAppointmentPage() {
  const { appointmentId = "" } = useParams();
  const userId = useAppSelector((state) => state.auth.user?.id);
  const [seat, setSeat] = useState<Seat>("loading");

  useEffect(() => {
    let current = true;
    setSeat("loading");
    PropertyContactRepository.appointment(appointmentId).then(
      (appointment) => current && setSeat(worksTheJob(appointment, userId) ? "worker" : "contact"),
      () => current && setSeat("worker"),
    );
    return () => {
      current = false;
    };
  }, [appointmentId, userId]);

  if (seat === "loading")
    return (
      <MainLayout breadcrumb={[{ name: "Loading...", href: "#" }]}>
        <Skeleton className="h-96 w-full rounded-lg" />
      </MainLayout>
    );
  return seat === "worker" ? <IndividualAppointmentUpdatePage /> : <ContactAppointmentPage />;
}
